module.exports = __webpack_public_path__ + "5c114213/img/document.e2130c6b.svg";